/* KÒRMESIC product page: variant picking, quantity, subscriptions, sticky bar, gallery thumbs, recently viewed. */
(function () {
  'use strict';
  function init() {
    var root = document.querySelector('[data-pdp]'); if (!root || !window.KM) return;
    var $ = function (s, r) { return (r || root).querySelector(s); }, $$ = function (s, r) { return Array.prototype.slice.call((r || root).querySelectorAll(s)); };
    var data = JSON.parse(document.querySelector('[data-product-json]').textContent);
    var form = $('[data-product-form]'), money = KM.money, qty = 1;
    var idIn = form && $('[data-variant-input]', form), atc = $('[data-atc]'), sb = document.querySelector('.stickybar');
    var track = $('.gal-track'), thumbs = $$('[data-thumb]');
    var variant = data.variants.filter(function (x) { return idIn && x.id === +idIn.value; })[0] || data.variants[0];

    function plan() { var r = form && form.querySelector('input[name=selling_plan]:checked'); return r && r.value ? r.value : ''; }
    function unit() { var p = plan(); return p && variant.plans[p] != null ? variant.plans[p] : variant.price; }
    function paint() {
      var u = unit(), p = plan(), was = variant.compare > variant.price ? variant.compare : (p ? variant.price : 0), off = variant.compare > variant.price ? Math.round((1 - variant.price / variant.compare) * 100) : 0;
      $('[data-price]').innerHTML = '<b' + (was ? ' class="now"' : '') + '>' + money(u) + '</b>' + (was ? '<s>' + money(was) + '</s>' : '') + (off ? '<span class="tag sale">Save ' + off + '%</span>' : '');
      var once = $('[data-once]'); if (once) once.textContent = money(variant.price);
      $$('[data-plan]').forEach(function (e) { var v = variant.plans[e.dataset.plan]; e.textContent = v != null ? money(v) : ''; });
      if (atc) { atc.disabled = !variant.available; if (!atc.classList.contains('is-done')) atc.textContent = variant.available ? 'Add to bag · ' + money(u * qty) : 'Sold out'; }
      $('[data-qnum]').textContent = qty; var qi = $('[data-qinput]'); if (qi) qi.value = qty;
      if (sb) { sb.querySelector('[data-sb-price]').textContent = money(u); var sbb = sb.querySelector('[data-sb-atc]'); sbb.disabled = !variant.available; sbb.textContent = variant.available ? 'Add · ' + money(u * qty) : 'Sold out'; }
      var ship = $('[data-shipbar]'); if (ship) ship.innerHTML = KM.shipBar((KM.cart().total_price || 0) + u * qty);
    }
    function pickVariant() {
      var chosen = $$('[data-opt]:checked').map(function (i) { return i.value; });
      var m = data.variants.filter(function (x) { return x.options.every(function (o, k) { return chosen[k] == null || chosen[k] === o; }); })[0];
      if (!m) return;
      variant = m; idIn.value = m.id;
      if (history.replaceState) history.replaceState(null, '', data.url + '?variant=' + m.id);
      if (m.media && track) { var slide = track.querySelector('[data-media-id="' + m.media + '"]'); if (slide) track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' }); }
      paint();
    }
    if (form) {
      form.addEventListener('change', function (e) { if (e.target.dataset.opt != null) pickVariant(); else paint(); });
      $$('[data-step]', form).forEach(function (b) { b.addEventListener('click', function () { qty = Math.min(99, Math.max(1, qty + +b.dataset.step)); paint(); }); });
      form.addEventListener('submit', function (e) {
        e.preventDefault(); if (!variant.available) return;
        var d = atc.dataset;
        d.add = variant.id; d.units = qty; d.img = data.img; d.name = data.title; d.drawer = '';
        if (plan()) d.plan = plan(); else delete d.plan;
        KM.addFromButton(atc);
        delete d.add; // km.js reads the data synchronously; clearing it keeps the next click on the form path
      });
    }
    if (sb) sb.querySelector('[data-sb-atc]').addEventListener('click', function () { if (form.requestSubmit) form.requestSubmit(); else atc.click(); });

    // thumbs follow the swipe gallery
    thumbs.forEach(function (b, i) { b.addEventListener('click', function () { track.scrollTo({ left: track.children[i].offsetLeft - track.offsetLeft, behavior: 'smooth' }); }); });
    if (track) track.addEventListener('scroll', function () { var n = Math.round(track.scrollLeft / (track.clientWidth || 1)); thumbs.forEach(function (b, i) { b.setAttribute('aria-current', i === n ? 'true' : 'false'); }); }, { passive: true });

    KM.onCart(function () { setTimeout(paint, 1500); });
    paint();

    // remember this product for "Recently viewed"
    try {
      var seen = JSON.parse(localStorage.getItem('km_seen') || '[]').filter(function (x) { return x.handle !== data.handle; });
      var v0 = data.variants[0];
      seen.unshift({ handle: data.handle, title: data.title, url: data.url, img: data.img, type: data.type, size: data.size, price: v0.price, compare: v0.compare, variant: v0.id, single: data.variants.length === 1, available: v0.available });
      localStorage.setItem('km_seen', JSON.stringify(seen.slice(0, 12)));
    } catch (e) { }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
